import { Plus } from 'lucide-react'
import type { QuestionsEmptyStateProps } from './questions-empty-state.interface'
import classes from './questions-empty-state.module.scss'

const EMPTY_STATE_TITLE = 'No custom questions yet'
const EMPTY_STATE_BODY =
  'Ask customers what you need to know before the appointment, like "What brings you in?" or "How did you hear about us?"'

export function QuestionsEmptyState({ disabled, onAdd }: QuestionsEmptyStateProps) {
  return (
    <div className={classes.root} data-testid="questions-empty-state">
      <div className={classes.title}>{EMPTY_STATE_TITLE}</div>
      <p className={classes.body}>{EMPTY_STATE_BODY}</p>
      <button type="button" className={classes.button} disabled={disabled} onClick={onAdd}>
        <Plus size={16} strokeWidth={2.5} aria-hidden="true" />
        Add a question
      </button>
    </div>
  )
}
